import { ISettingsService } from "../typings/typings";
declare var Drupal: any;

export function SettingsService(): ISettingsService {
    if (typeof Drupal === "undefined") {
        Drupal = {};
    }

    if (typeof Drupal.settings === "undefined") {
        Drupal.settings = {};
    }

    return Drupal.settings;
}
